export default {
  name: 'NrPanel',
  props: {
    title: {
      type: String
    },
    tagline: {
      type: String
    }
  }
};